<lib-guest-form (leavePage)="leavePage($event)" (checkoutAuthSubmit)="goToCheckout($event)"></lib-guest-form>
